import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { AclInState } from "./acl.type";

export const initialState: AclInState = {
  data: null,
  isLoading: false,
};

export const aclSlice = createSlice({
  name: "acl",
  initialState,
  reducers: {
    /* eslint-disable no-param-reassign */
    setAcl: (
      state,
      action: PayloadAction<
        Pick<AclInState, "data" | "isLoading" | "refetchAcl">
      >
    ) => {
      state.data = action.payload.data;
      state.isLoading = action.payload.isLoading;
      state.refetchAcl = action.payload.refetchAcl;
    },
  },
});

export const { setAcl } = aclSlice.actions;

export const { reducer: aclReducer } = aclSlice;
